import { Component } from '@angular/core';

@Component({
  selector: 'itl-listitem-status',
  template: '<ng-content></ng-content>',
})
export class ListitemStatusComponent {}
